import axios from 'axios';
import { createSignedPostRequest } from 'utils/createSignedRequestsHelpers';

export const getCardImageUploadSignedUrl = async (userId, cardId, fileType) => {
  const apiPath = `cards/user/${userId}/card/${cardId}/image-upload-signed-url`;

  const data = {
    contentType: fileType,
  };

  const signedRequest = await createSignedPostRequest({
    apiPath,
    body: data,
  });

  const response = await axios(signedRequest);

  return response.data;
};
